import { gql, TypedDocumentNode } from "@apollo/client";

import {
  FlowsProjectRoleBinding,
  Maybe,
  MutationFlowsProjectRoleBindingDeleteArgs,
} from "types/generated";

type FlowsProjectRoleBindingDeleteData = {
  flowsProjectRoleBindingDelete: Maybe<Pick<FlowsProjectRoleBinding, "id">>;
};

export const FLOWS_PROJECT_ROLE_BINDING_DELETE: TypedDocumentNode<
  FlowsProjectRoleBindingDeleteData,
  MutationFlowsProjectRoleBindingDeleteArgs
> = gql`
  mutation FlowsProjectRoleBindingDelete($id: ID!) {
    flowsProjectRoleBindingDelete(id: $id) {
      id
    }
  }
`;
